import SparkleEyebrow from "@/components/motion/SparkleEyebrow";

export const SectionHeading = ({
  eyebrow,
  title,
  subtitle,
  align = "left",
  size = "section",
  className = "",
  testId,
}) => {
  const alignment =
    align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  const titleClass =
    size === "display" ? "wit-heading-display" : "wit-heading-section";

  return (
    <div
      className={`flex flex-col ${alignment} max-w-3xl gap-3 ${className}`}
      data-testid={testId}
    >
      {eyebrow && (
        <SparkleEyebrow
          className={`wit-eyebrow text-raspberry ${align === "center" ? "justify-center" : ""}`}
        >
          {eyebrow}
        </SparkleEyebrow>
      )}
      <h2 className={titleClass}>{title}</h2>
      {subtitle && <p className="wit-body max-w-lg">{subtitle}</p>}
    </div>
  );
};

export default SectionHeading;
